<template>
  <div class="detail-card">
    <h1>产品详情</h1>
    <ul>
      <li v-for="(item,index) in list" :key="index">
        <span class="title-box">{{item.title}}</span>
        <span class="content-box">{{item.content}}</span>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    props: {
      cardData: Object
    },
    data(){
      return {};
    },
    computed: {
      list(){
        const list = [];
        const {productData} = this.cardData;
        const Property = JSON.parse(productData.Property || '{}');
        const packCode = localStorage.getItem('packCode');
        list.push({title: '产品身份证', content: packCode});
        Object.keys(Property).forEach(key => {
          list.push({title: key, content: Property[key]});
        });
        return list.filter(item => item.content);
      }
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .detail-card {
    color: #ffffff;
    h1 {
      padding: 0;
      margin: 0;
      font-size: 0.35rem;
      line-height: 0.9rem;
      text-align: center;
      font-weight: normal;
    }
    ul {
      font-size: 0;
      height: 3.1rem;
      overflow: hidden;
      overflow-y: auto;
      li {
        display: block;
        white-space: nowrap;
        margin-left: 0.3rem;
        margin-right: 0.3rem;
        margin-bottom: 7px;
      }
      span {
        font-size: 18px;
        white-space: normal;
      }
    }
    .title-box, .content-box {
      display: inline-block;
      vertical-align: top;
    }
    .title-box {
      width: 1.99rem;
    }
    .content-box {
      margin-left: 0.01rem;
      width: 3.3rem;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
</style>



// WEBPACK FOOTER //
// detail-card.vue?71415836